import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsRightChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9 15H0l7-7l-7-7h9l7 7z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsRightChevron
